<template>
  <td v-if="renderCell && isEditable" :class="className" @click="cellclick">
    <el-time-picker v-if="isTimeFormat" ref="cellinput" class="!w-full" v-model="localValue" :format="dateTimeFormat" :value-format="dateValueFormat" popper-class="fecha-template-picker" size="mini" tabindex="0" arrow-control @change="change" @blur="blur" />
    <el-date-picker v-else ref="cellinput" class="!w-full" v-model="localValue" :type="formatType" :format="dateTimeFormat" :value-format="dateValueFormat" popper-class="fecha-template-picker" size="mini" tabindex="0" @change="change" @blur="blur" />
  </td>
  <td v-else-if="renderCell" :class="className" @click="cellclick">{{ value }}</td>
  <td v-else-if="renderArrow" :key="'g' + columnIndex" :class="'k-group-cell'" />
  <td v-else-if="columnIndex <= level" key='g-colspan' :colSpan="columnsCount - columnIndex">
    <p class='k-reset'>
      <a @click="onGroupClick" tabIndex='-1' href='#' :class="expanded ? 'k-i-collapse k-icon' : 'k-i-expand k-icon'" />
      {{ groupHeader }}
    </p>
  </td>
</template>
<script>
import moment from 'moment'
import { i18n } from '@/i18n'
import getNestedValue from '@/services/functions/getNestedValue'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'
import { discard } from '@/services/functions/preserve&discard'

export default {
  name: 'fecha-template',
  emits: {
    click: null
  },
  props: {
    field: String,
    dataItem: Object,
    format: {
      type: String,
      default: 'numeric_date'
    },
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String,
    curEditField: [String, null],
    editType: {
      type: [String, Boolean],
      default: 'row'
    },
    editField: {
      type: String,
      default: 'inEdit'
    },
    extraparams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      localValue: '',
    }
  },
  mounted () {
    this.localValue = this.dateValue
    if (this.isEditable && this.curEditField === this.field && this.$refs.cellinput) {
      this.$refs.cellinput.focus()
    }
  },
  watch: {
    dateValue: function (value, oldValue) {
      if (value !== oldValue) {
        this.localValue = value
      }
    }
  },
  computed: {
    renderArrow () {
      var returnValue =
        this.columnIndex === undefined ||
        this.level === undefined ||
        this.columnIndex < this.level ||
        this.columnsCount === undefined ||
        this.rowType !== 'groupHeader' ||
        this.dataItem[this.field] === undefined
      // return returnValue && this.dataItem[this.field]
      return returnValue && this.dataItem[this.field] !== undefined
    },
    renderCell () {
      return this.field !== undefined && this.rowType !== 'groupHeader'
    },
    inEdit: function () {
      return getNestedValue(this.editField, this.dataItem) === true
    },
    value: function () {
      return this.formatDate(getNestedValue(this.field, this.dataItem))
    },
    groupHeader () {
      const value = this.value
      if (this.rowType === 'groupHeader') {
        const template = this.extraparams.groupHeaderTemplate
        if (typeof template === 'function') {
          return template(this.dataItem, { value, ...discard([template.name], this.extraparams) })
        }
      }
      return value
    },
    separators () {
      return this.extraparams?.separators ?? {}
    },
    dateTimeFormat: function () {
      const formatKey = this.format
      const locale = i18n.locale || 'es'
      if (i18n.de(formatKey)) {
        return getLocaleDateTimeFormat(formatKey, locale, this.separators)
      }
      return this.format
    },
    formatType: function () {
      const format = this.dateTimeFormat
      const hasTime = format.includes('H') || format.includes('h') || format.includes('m') || format.includes('s')
      const hasDate = format.includes('y') || format.includes('d') || format.includes('M')
      if (hasTime) {
        if (hasDate) {
          return 'datetime'
        }
        return 'time'
      }
      return 'date'
    },
    isDateTimeFormat: function () {
      return this.formatType === 'datetime'
    },
    isTimeFormat: function () {
      return this.formatType === 'time'
    },
    isDateFormat: function () {
      return this.formatType === 'date'
    },
    dateValueFormat: function () {
      const timeFields = ['HH', 'mm', 'ss']
      const tokens = this.dateTimeFormat.split(/[^a-zA-Z]+/)
      const curTime = tokens.filter(token => timeFields.includes(token))
      const finalTime = timeFields.map(unidad => curTime.includes(unidad) ? unidad : '[00]').join(':')
      return (this.isTimeFormat ? `[1970-01-01T]${finalTime}` : `yyyy-MM-dd[T]${finalTime}`).replaceAll(/\](:?)\[/g, '$1')
    },
    dateValue: function () {
      const strDate = getNestedValue(this.field, this.dataItem)
      if (!this.isValidDate(strDate)) return strDate
      return moment(strDate).locale(i18n.locale).format(this.dateValueFormat.replace('dd', 'DD'))
    },
    editable: function () {
      return !!this.extraparams.editable
    },
    isCellEditable: function () {
      return this.editType === 'cell'
    },
    isEditable: function () {
      return this.editable && this.inEdit && (!this.isCellEditable || this.curEditField === this.field)
    }
  },
  methods: {
    onClick (e) {
      // @ts-ignore
      this.$emit('click', e, this.dataItem, this.expanded)
    },
    onGroupClick (e) {
      // @ts-ignore
      this.$emit('groupclick', e, this.dataItem, this.expanded)
    },
    change (value) {
      var dataItem, field
      if (typeof value === 'object' &&
        Object.hasOwnProperty.call(value, 'dataItem') &&
        Object.hasOwnProperty.call(value, 'field') &&
        Object.hasOwnProperty.call(value, 'value')) {
        ({ dataItem, field, value } = value)
      } else {
        dataItem = this.dataItem
        field = this.field
      }
      this.$emit('change', { dataItem, field, value })
    },
    blur (e) {
      this.$emit('blur', e)
    },
    cellclick (e) {
      this.$emit('cellclick', { dataItem: this.dataItem, field: this.field, event: e })
    },
    formatDate: function (strDate, format = this.format, separators = this.separators) {
      if (!this.isValidDate(strDate)) return strDate
      if (i18n.de(format)) return i18n.d(strDate, format, separators)
      return moment(strDate).locale(i18n.locale).format(format) // .format('DD-MM-yyyy HH:mm')
    },
    isValidDate: function (strDate) {
      if (strDate === undefined || strDate === null) return false
      return !Number.isNaN(new Date(strDate).getTime())
    },
    getNestedValue: getNestedValue
  }
}
</script>

<style scoped>
.bg-success-p{
  background-color: black;
}
</style>
